module.exports = __webpack_public_path__ + "img/Efdot-Hat-04@2x.99522c3e.jpg";